import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LanguageSelectorService } from '../language-selector/service/language-selector.service';

@Component({
  selector: 'prep-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent implements OnInit {

  @Input() current: string;
  @Input() crumbs: any[] = [];
  @Input() hideTitle: boolean = false;

  // S10/S12 (WCAG 3.1.1): localisation set for the active language. Defaults to EN
  // so template/error bindings are never undefined before language$ first emits.
  dashLangText: string = 'Dashboard';

  constructor(
    public router: Router,
    private languageSelectorService: LanguageSelectorService
  ) {
    this.languageSelectorService.language$.subscribe((lang) => {
      switch (lang?.code) {
        case 'es': this.dashLangText = 'Tablero'; break;
        case 'it': this.dashLangText = 'Dashboard'; break;
        default: this.dashLangText = 'Dashboard'; break;
      }
    });
  }

  ngOnInit() {
  }

  // Prevent navigation when the user activates the current-page link.
  // The aria-current="page" + focusable role=link is what AT and
  // keyboard users need; reloading the same route would be user-hostile.
  onCurrentClick(event: Event): void {
    event.preventDefault();
  }

}
